import { render } from "./StickerBox.vue?vue&type=template&id=0a945f8e&scoped=true&ts=true"
import script from "./StickerBox.vue?vue&type=script&lang=ts"
export * from "./StickerBox.vue?vue&type=script&lang=ts"

import "./StickerBox.vue?vue&type=style&index=0&id=0a945f8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a945f8e"]])

export default __exports__